import { bindActionCreators } from 'redux';
import * as commonDataListEventsActions from '../actions/commonDataListEventsActions';

/**
 * React-redux bindings
 * @param {*} state the current state
 * @returns {object} props
 */
export function mapStateToProps(state) {
    return {
        events: state.commonDataListEvents.events,
        commonDataEvents: state.commonData,
        metaData: state.metaData,
    };
}

/**
 * React-redux bindings
 * @param {*} dispatch the dispatcher function
 * @returns {object} betfeed actions
 */
export function mapDispatchToProps(dispatch) {
    return bindActionCreators(commonDataListEventsActions, dispatch);
}
